import bankapis  from "../../api/bank";

export default {
    name: "BankList",
    data() {
        return {
            detailVisible:false,
            dataDetail:{},
            userList:[],
            type:"",
            query: {
                keyword: "",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "BankID",
                    "label": "银行编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "BankName",
                    "label": "银行名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "UserName",
                    "label": "联系人",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "Tel",
                  "label": "联系人电话",
                  "width": "140",
                  "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "创建时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            tel:""
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
  },
    created() {
      this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    // watch: {
    //   dataDetail: {
    //     handler(newVal) {
    //       this.tel=newVal.UserID
    //       var userList=this.userList;
    //       for(var i=0;i<userList.length;i++)
    //       if(userList[i].UserID==newVal.UserID){
    //         var tel=userList[i].Tel;
    //         this.tel=tel;
    //       }
    //      },
    //      deep: true,
    //   }
    // },
    methods: {
        getData(){
          let param=this.query;
          bankapis.getBankList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
      },
      selectUser(){
      var UserID=this.dataDetail.UserID;
      if(UserID==''){
        this.tel="";return;
      }
      var userList=this.userList;
          for(var i=0;i<userList.length;i++)
          if(userList[i].UserID==UserID){
            var tel=userList[i].Tel;
            this.tel=tel;
          }
      },
      getBankById(){
          let param={
            bankId: "1"
          };
         bankapis.getBankById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addOrUpdateBank(){
          let param=this.$data.dataDetail;
          if(param.UserID==""||param.BankName==""){
            this.$message.error("名称或联系人不能为空");
            return;
          }
          if(this.type=="add")this.addBank(param);
          else this.updateBank(param);
      
      },
      addBank(param){
        bankapis.addBank(param).then(res => {
          if(res){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else{
            this.$message.error("新增失败");
          }
      });
      },
       updateBank(param){
         bankapis.updateBank(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        getUserList(user){
          let param={
            type:"0",
            keyword:""
          }
          bankapis.getUserListByMenuId(param).then(res => {
            if(user)res.push(user);
            this.userList=res;
        });
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          this.getUserList(null);
          this.$data.detailVisible=true;
          this.dataDetail={
            BankName:"",
            UserID:"",
          }
          this.tel="";
          this.type="add";
        },
        handleUpdate(index, row){
          var user={
            UserName:row.UserName,
            UserID:row.UserID,
            Tel:row.Tel
          }
          this.getUserList(user);
          this.dataDetail={
            BankName:row.BankName,
            Id:row.BankID,
            UserID:row.UserID
          }
          this.tel=row.Tel;
          this.type="update";
          this.$data.detailVisible=true;
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.BankID
                  };
                 bankapis.deleteBank(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
